'use client';

import {useState} from 'react';

const TOCTree = props => {
  const {children} = props;
  if (children === undefined || children.length === 0) {
    return null;
  }

  return <ul>{children.map(e => <li key={e.id}><a href={`#${e.id}`} className='nav-link blog-toc-link'>{e.value}</a><TOCTree>{e.children}</TOCTree></li>)}</ul>;
};

const TableOfContents = props => {
  const {hide_toc = false, toc} = props;
  const [isVisible, setIsVisible] = useState(false);

  if (hide_toc) {
    return null;
  }

  return <div className='blog-sidebar'>
    <div 
      className={`blog-hoverable-toc blog-toc ${isVisible ? 'visible' : ''}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <button 
        className='blog-toc-hide-arrow'
        onClick={() => setIsVisible(false)}
        aria-label='Hide table of contents'
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <span className='blog-sidebar-heading'>Table Of Contents</span>
      <hr/>
      <TOCTree>{toc}</TOCTree>
    </div>
    {!isVisible && (
      <button 
        className='blog-toc-toggle-arrow'
        onClick={() => setIsVisible(true)}
        aria-label='Show table of contents'
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    )}
  </div>
};

export default TableOfContents;
